module.exports = __webpack_public_path__ + "media/img/home/sections-parralax/directions-parralax1-e0d3b7e6f4d2f9945959fde79a333365.png";